var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBrokenMagnifyingGlass = function SvgBrokenMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 168,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FED607",
    d: "M108.744 72.062c12.186-22.184 4.199-49.982-17.838-62.087C68.868-2.131 41.124 6.04 28.938 28.225c-12.186 22.184-4.2 49.982 17.838 62.087 22.038 12.106 49.782 3.935 61.968-18.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#50EEF6",
    d: "M69.109 86.39c19.972 0 36.163-16.19 36.163-36.163 0-19.972-16.19-36.163-36.163-36.163-19.973 0-36.164 16.191-36.164 36.163 0 19.973 16.191 36.164 36.164 36.164Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#28736D",
    d: "m69.118 53.288 10.63-9.424s-1.18-.736-2.507-.736c-1.326 0-11.576.293-11.576.293l-.37-4.423S59.91 50.39 59.69 51.384c-.22.994.294 2.36.294 2.36l2.95 9.29.627 1.55 9.07 6.304-2.764-8.737 2.764-5.64-3.514-3.223Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#28736D",
    d: "m54.605 25.984 10.84 11.944-3.76 11.503-7.08-23.447Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7101",
    d: "m38.801 84.63-28.02 50.998s-3.71 9.276 4.574 13.826c8.28 4.55 13.78-4.49 14.14-5.146.36-.657 21.75-39.394 21.75-39.394"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5FAFE",
    d: "M83.448 7.12s5.877 2.518 8.063 3.718c2.187 1.2 6.32 4.04 6.32 4.04s4.484-7.64-2.623-11.547C88.1-.572 84.508 5.708 83.45 7.118l-.003.003ZM35.328 82.014s-.946-.093-1.546 1c-.6 1.094-.617 2.934-.617 2.934s-1.643.663-2.367 1.973c-.72 1.313-1.373 6.646 10.907 13.82 12.284 7.173 15.657.773 15.727.387.07-.387.046-2.677.046-2.677s3.08-1.723 2.39-4.093c0 0-9.143-2.507-13.33-5-4.186-2.494-11.216-8.347-11.216-8.347l.006.003ZM9.908 143.048s-2.203.64-2.633 1.683c-.43 1.043-.207 5.297 5.756 8.43 5.964 3.133 10.137 2.013 10.54.24.404-1.77-.32-3.307-.32-3.307s-4.793 1.21-7.903-.64c-3.11-1.85-5.447-6.406-5.447-6.406h.007Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED607",
    d: "m13.518 153.571-5.303-4.337s-2.72 1.067-4.44 3.68c-1.72 2.614-2.503 8.444 3 11.897 6.39 3.653 10.627-1.99 11.89-4.283 1.26-2.297.704-5.164.704-5.164s-4.267-.78-5.847-1.79l-.004-.003Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#28736D",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m49.075 19.79 16.26 17.917-5.973 14.6 3.98 11.944 8.996 6.423-8 9.503v5.974"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#28736D",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M61.021 58.278 54.385 60.6l-10.287-1.99-8.627 4.977M69.008 53.214l11.257-10.196 3.317-9.624 14.93-3.983"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#28736D",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m65.335 37.708.33 12.606 9.953 8.627L88.89 69.56l9.62.993"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#28736D",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m72.632 70.888-2.984-8.96 3.317-5.307M80.265 43.018l-14.71.33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFED8F",
    d: "M100.815 18.2c-.237 2.36 1.91 6.628 3.607 9.688 4.956 8.93 6.96 19.466 5.63 29.593-.21 1.587-.5 3.173-1.034 4.68-.683 1.933-1.746 3.707-2.78 5.48-1.103 1.893-2.186 3.823-2.813 5.923-.627 2.1-.77 4.407 0 6.457 0 0 13.673-11.047 10.133-39.803-2.506-10.47-10.446-20.587-12.743-22.017Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M68.875 96.088c25.24 0 45.7-20.461 45.7-45.7 0-25.24-20.46-45.7-45.7-45.7-25.24 0-45.7 20.46-45.7 45.7 0 25.239 20.46 45.7 45.7 45.7Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M69.018 86.408c20.035 0 36.277-16.242 36.277-36.277S89.053 13.854 69.018 13.854 32.742 30.096 32.742 50.131s16.241 36.277 36.276 36.277Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5FAFE",
    d: "M78.685 32.074c7.2 5.607 10.19 10.37 11.063 20.244.687 2.396 1.1 6.156 4.6 6.583 3.5.43 4.307-4.24 4.307-4.24 1.917-11.807-2.74-22.117-12.923-29.42-2.444-1.77-6.334-4.014-9.37-.237-3.037 3.777 2.32 7.07 2.32 7.07h.003Z",
    opacity: 0.9
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M83.375 6.888a8.364 8.364 0 1 1 14.937 7.503c-.127.23-.264.453-.407.666M59.808 95.224c.323.994.313 1.887-.083 2.614-1.594 2.896-8.794 2-16.084-2.007-7.29-4.007-11.91-9.603-10.316-12.5.396-.723 1.146-1.213 2.16-1.473"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M57.422 99.568c.27 1.093.2 2.096-.264 2.933-1.843 3.353-9.246 2.827-16.536-1.177-7.29-4.006-11.707-9.973-9.864-13.326.46-.84 1.27-1.434 2.337-1.794"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m32.729 95.49-21.584 39.288c-3.1 5.64-.653 12.006 4.13 14.633 4.784 2.627 11.137.71 13.95-4.41 2.504-4.557 18.52-33.71 22.024-40.083"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.198 150.084c.647 1.257.78 2.457.264 3.394-1.25 2.276-5.857 2.15-10.287-.284-4.43-2.433-7.007-6.253-5.757-8.53.47-.856 1.417-1.373 2.65-1.553"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.482 155.301a9 9 0 0 1-.98 5.97c-2.343 4.263-7.567 5.897-11.663 3.643-4.1-2.253-5.524-7.533-3.18-11.8a9.013 9.013 0 0 1 4.116-3.86"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5FAFE",
    d: "M39.692 41.608c-.26 1.973.163 4.136 1.57 5.543 1.407 1.406 3.92 1.75 5.39.406.933-.853 1.29-2.17 1.403-3.43.114-1.26.024-2.54.264-3.78.28-1.45.996-2.783 1.336-4.22.34-1.436.207-3.15-.92-4.103-1.233-1.043-3.193-.727-4.463.273-2.427 1.914-4.187 6.334-4.577 9.31h-.003Z",
    opacity: 0.9
  })));
};
export default SvgBrokenMagnifyingGlass;